var validateAlgorithms = function validateAlgorithms(option, algorithms) {
  if (algorithms !== undefined && (!Array.isArray(algorithms) || algorithms.some(function (s) {
    return typeof s !== 'string';
  }))) {
    throw new TypeError("\"".concat(option, "\" option must be an array of strings"));
  }
  if (!algorithms) {
    return undefined;
  }
  return new Set(algorithms);
};
export default validateAlgorithms;